/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ReferenceResponse {
    getFixupPrototypeFunction() { return ReferenceResponse.fixupPrototype; }

    static newInstance(model: Partial<ReferenceResponse>): ReferenceResponse {
        let obj = Object.assign(new ReferenceResponse(), model);
        ReferenceResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ReferenceResponse>): ReferenceResponse {
        if (!model) return null;
        return ReferenceResponse.newInstance(<ReferenceResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ReferenceResponse) {
        if (!obj) return;

        models.ReferenceResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ReferenceResponse): boolean {
        Object.setPrototypeOf(obj, ReferenceResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.control_baseline) {
            models.ReferenceModelList.fixupPrototype(this.control_baseline);
        }
        if (this.control_family) {
            models.ReferenceModelList.fixupPrototype(this.control_family);
        }
        if (this.control_statement) {
            models.ReferenceModelList.fixupPrototype(this.control_statement);
        }
        if (this.control_name) {
            models.ReferenceModelList.fixupPrototype(this.control_name);
        }
        if (this.abstracted_control_uRI) {
            models.ReferenceModelList.fixupPrototype(this.abstracted_control_uRI);
        }
        if (this.services) {
            models.ReferenceModelList.fixupPrototype(this.services);
        }
    }

    /**
     * Control Baseline
     */
    control_baseline: models.ReferenceModelList;

    /**
     * Control Family
     */
    control_family: models.ReferenceModelList;

    /**
     * Control Statement
     */
    control_statement: models.ReferenceModelList;

    /**
     * Control Name
     */
    control_name: models.ReferenceModelList;

    /**
     * Abstracted Control URI
     */
    abstracted_control_uRI: models.ReferenceModelList;

    /**
     * Services
     */
    services: models.ReferenceModelList;

}
